export default __webpack_public_path__ + "static/media/stat-active-orders.a995f313.svg";